import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles({
  card: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

export function ImageCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.card} onClick={props.onClick}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={props.imgSrc}
          style={{ backgroundSize: 'contain', margin: 10 }}
          title="Contemplative Reptile"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {props.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {props.text}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {props.text2}
          </Typography>
        </CardContent>
      </CardActionArea>
      {/* 
            <CardActions>
                {props.action_1 ?
                    <Button onClick={props.onClickAction1} size="small" color="primary">
                        {props.action_1}
                    </Button>
                    : null}

                {props.action_2 ?
                    <Button onClick={props.onClickAction2} size="small" color="primary">
                        {props.action_2}
                    </Button>
                    : null}
            </CardActions> */}
    </Card>
  );
}
